var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashStrokeFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 2,
    viewBox: "0 0 35 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2H3.63634V0H0.5V2ZM19.3209 2H22.4572V0H19.3209V2ZM28.7276 2H25.5913V0H28.7276V2ZM31.8636 2H34.9999V0H31.8636V2ZM16.1808 2H13.0445V0H16.1808V2ZM6.7706 2H9.90694V0H6.7706V2Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashStrokeFour);
export default __webpack_public_path__ + "static/media/dash-stroke-four.7c4b6176d135a408071345461aabf140.svg";
export { ForwardRef as ReactComponent };